import { AnalyticsEventTopic } from '~/modules/analytics/analyticsHelper';
import { AnalyticsEvent } from '~/modules/services/analyticsService';
import { GA4FormCompletionEvent, GTMBaseEvent, GtmEventType } from './gtmEventType';
import { getQueryStringValue } from './gtmEventTypeHelper';

export type FormCompletionAnalyticsEvent = AnalyticsEvent & {
    convertingPage: string;
    formEnvironmentType: string;
    formExperienceType: string;
    formJoinId: string;
    formName: string;
    formPrimaryProductInterest: string;
    hashedEmail: string;
    offerId: string;
    offerType: string;
    partnerPromoCode?: string;
};

export class GtmFormCompletionType extends GtmEventType {
    canHandle(event: GTMBaseEvent): boolean {
        return event.topic === AnalyticsEventTopic.ANALYTICS_FORM_COMPLETION;
    }

    getBody(event: FormCompletionAnalyticsEvent): GA4FormCompletionEvent {
        return {
            event: 'custEv_formCompletion',
            converting_page: event.convertingPage,
            internal_driver: getQueryStringValue(event.url, 'd'),
            form_environment_type: event.formEnvironmentType,
            form_experience_type: event.formExperienceType,
            form_join_id: event.formJoinId,
            form_name: event.formName,
            form_primary_product_interest: event.formPrimaryProductInterest,
            hashed_email: event.hashedEmail,
            offer_id: event.offerId,
            offer_type: event.offerType,
            partner_promo_code: event.partnerPromoCode || '',
        };
    }
}
